var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame48095978(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 46,
    width: 45,
    height: 45,
    rx: 22.25,
    transform: "rotate(-180 46 46)",
    stroke: "#FFFAE6",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1761 18.9391C29.309 18.7507 28.5247 18.2958 27.9355 17.6396C27.3464 16.9835 26.9828 16.1598 26.8969 15.2867V14.9086H23.8962V26.6564C23.8968 27.1777 23.7314 27.686 23.4234 28.1092C23.1154 28.5324 22.6804 28.8492 22.1801 29.0146C21.6798 29.18 21.1395 29.1857 20.6357 29.0308C20.132 28.876 19.6903 28.5684 19.3732 28.1518C19.0892 27.783 18.9153 27.343 18.8711 26.8816C18.827 26.4202 18.9144 25.9558 19.1234 25.541C19.3325 25.1261 19.6548 24.7773 20.054 24.534C20.4533 24.2907 20.9134 24.1626 21.3825 24.1642C21.6419 24.1627 21.9 24.2004 22.1479 24.2759V21.2681C21.8594 21.2328 21.5687 21.2184 21.2781 21.2251C20.2076 21.2534 19.1688 21.5894 18.2887 22.1921C17.4086 22.7949 16.7255 23.6381 16.323 24.6185C15.9206 25.599 15.8162 26.6741 16.0227 27.7123C16.2292 28.7504 16.7377 29.7065 17.4858 30.4635C18.2525 31.2337 19.2336 31.7613 20.3045 31.9793C21.3754 32.1973 22.4877 32.0958 23.5001 31.6878C24.5125 31.2798 25.3793 30.5836 25.9903 29.6877C26.6013 28.7919 26.929 27.7367 26.9317 26.6564V20.6407C28.142 21.4949 29.5933 21.9518 31.0806 21.947V19.0251C30.7885 19.0263 30.497 18.9975 30.2109 18.9391H30.1761Z",
    fill: "#FFFAE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame48095978);
export default __webpack_public_path__ + "static/media/frame-48095978.f51fec86686d28532d2ed88f3459af46.svg";
export { ForwardRef as ReactComponent };